import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { useUpdateGeneralContractor } from '../queries/generalContractorQueries';
import { useGeneralContractorStore } from '../stores/generalContractorStore';
import { IGeneralContractorProperty } from '@apply/api/src/api/usersApi';

export const EditGeneralContractorModal: React.FC = () => {
    const { mutate: saveGeneralContractor } = useUpdateGeneralContractor();

    const { modalContractor, set_modalContractor, reset_modalContractor, updateBfiAuthorized } = useGeneralContractorStore();

    const save = async () => {
        if (!modalContractor) return;

        await saveGeneralContractor(modalContractor);

        reset_modalContractor();
    };

    const authorizedPropertyLabel = ({ property }: { property: IGeneralContractorProperty }) => {
        const additionalInfo: string[] = [];

        if (property.bfiNumber && property.bfiNumber.trim() !== '') {
            additionalInfo.push(property.bfiNumber);
        }

        if (property.borrowerEntity && property.borrowerEntity.trim() !== '') {
            additionalInfo.push(property.borrowerEntity);
        }

        return (
            <span>
                <b>Authorize:</b>
                <br />
                {property.fullAddress}
                {additionalInfo.length > 0 && (
                    <>
                        <br />({additionalInfo.join(', ')})
                    </>
                )}
            </span>
        );
    };

    if (!modalContractor) return null;

    return (
        <>
            <Dialog
                maxWidth='lg'
                open={!!modalContractor}
                onClose={() => reset_modalContractor()}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container principal-modal'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex={-1}
                            role='dialog'
                            style={{ width: '1100px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1
                                        style={{
                                            height: '50px',
                                            marginTop: '15px',
                                        }}
                                    >
                                        {modalContractor ? 'Edit General Contractor' : 'Add General Contractor'}
                                    </h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={() => reset_modalContractor()}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>

                                <div
                                    className='scrollable-content'
                                    style={{ margin: '10px' }}
                                >
                                    <TabPanel>
                                        <Item
                                            title='Details'
                                            icon='home'
                                        >
                                            <div
                                                className='standard-form'
                                                style={{
                                                    padding: '0 10px 0 10px',
                                                }}
                                            >
                                                <h2
                                                    style={{ marginTop: 30 }}
                                                    className='decorated sectionHeader'
                                                >
                                                    Contact Information
                                                </h2>
                                                <div className='row'>
                                                    <div className='columns small-12 large-4 formColumn'>
                                                        <label htmlFor='firstName'>
                                                            First Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            id='firstName'
                                                            name='firstName'
                                                            value={modalContractor.firstName}
                                                            onChange={(e) =>
                                                                set_modalContractor({
                                                                    ...modalContractor,
                                                                    firstName: e.target.value,
                                                                })
                                                            }
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-4 formColumn'>
                                                        <label htmlFor='firstName'>
                                                            Last Name
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            type='text'
                                                            id='lastName'
                                                            name='lastName'
                                                            value={modalContractor.lastName}
                                                            onChange={(e) =>
                                                                set_modalContractor({
                                                                    ...modalContractor,
                                                                    lastName: e.target.value,
                                                                })
                                                            }
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className='columns small-12 large-4 formColumn'>
                                                        <label htmlFor='email'>
                                                            Email
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <input
                                                            className='readOnly'
                                                            type='text'
                                                            id='email'
                                                            name='email'
                                                            value={modalContractor.email}
                                                            readOnly={true}
                                                        />
                                                    </div>
                                                </div>
                                                <h2
                                                    style={{ marginTop: 30 }}
                                                    className='decorated sectionHeader'
                                                >
                                                    Properties
                                                </h2>
                                                {modalContractor.properties.map((property) => {
                                                    return (
                                                        <div className='columns small-12 large-4 formColumn'>
                                                            <YesNoToggleButton
                                                                id={`Property-${property.id}`}
                                                                value={property.bfiAuthorized}
                                                                onItemClick={(e) =>
                                                                    updateBfiAuthorized(property.id, e.itemData?.id === 'Yes')
                                                                }
                                                                width='230px'
                                                                height='40px'
                                                                label={authorizedPropertyLabel({ property })}
                                                                labelSize={ToggleButtonLabelSize.Medium}
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </Item>
                                    </TabPanel>
                                </div>
                                <div
                                    className='button-footer'
                                    style={{
                                        marginRight: '10px',
                                        marginLeft: '10px',
                                        textAlign: 'right',
                                    }}
                                >
                                    <button
                                        style={{ marginRight: '10px' }}
                                        type='button'
                                        className='button primary'
                                        title='Save changes and close'
                                        onClick={save}
                                    >
                                        Save & Exit
                                    </button>
                                    <button
                                        type='button'
                                        className='button hollow'
                                        data-dismiss='modal'
                                        onClick={() => reset_modalContractor()}
                                        title='Abandon changes and close'
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};
